import { GET_COURSE_SECTIONS, GET_COURSE_SECTION, RESET_COURSE_SECTIONS, REFRESH_COURSE_SECTIONS } from '../types';
import course from './course';

export default function (courses = [], action) {
  switch (action.type) {
    case GET_COURSE_SECTIONS:
      return processSections(action.sections);
    case GET_COURSE_SECTION:
      return addCourseParts(courses, action.section);
    case REFRESH_COURSE_SECTIONS:
      const updated = processSections(action.sections);
      courses.forEach((course, idx) => {
        updated[idx].parts = course.parts
      });
      return updated;
    case RESET_COURSE_SECTIONS:
      return [];
    default:
      return courses;
  }
}

function processSections(data) {
  let lastAccessibleIdx = data.reduce((lastIdx, val, idx) => val.accessible ? idx : lastIdx, -1);
  const processed = data.map((section, idx) => {
    let game = false;
    const sub = section.title.substr(0, 4);
    if (sub === 'Gry ' || sub === 'Game') game = true;
    const slug = slugify(section.title);
    if (idx <= lastAccessibleIdx) section.accessible = true;
    return { ...section, game, slug, parts: [] };
  });
  return processed;
}

function addCourseParts(courses, section) {
  const { id, parts } = section;
  const courseCopy = [...courses];
  let idx = courses.findIndex(course => course.id === id);
  const currentCourse = courseCopy[idx];
  currentCourse.parts = addSlugs(parts);
  return courseCopy;
}

function addSlugs(parts) {
  const slugs = [];
  parts.forEach(p => {
    const slug = slugify(p.title);
    let idx = 2;
    if (slugs.indexOf(slug) === -1) {
      slugs.push(slug);
      p.slug = slug;
    } else {
      let slug2 = slug + idx++;
      while (slugs.indexOf(slug2) !== -1) {
        slug2 = slug + idx++;
      }
      p.slug = slug2;
      slugs.push(slug2);
    }
  });
  return parts;
}

function slugify(string) {
  const a = 'żśźęćńółĄŻŚŹĘĆŃÓŁ·/_,:;';
  const b = 'zszecnolazszecnol------';
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-')
    .replace(p, c => b.charAt(a.indexOf(c)))
    .replace(/&/g, '-and-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}
